<template>
  <van-tabbar v-model="active" active-color="#f5222d" :fixed="false">
    <van-tabbar-item to="/" icon="wap-home">首页</van-tabbar-item>
    <van-tabbar-item to="/explore" icon="search">发现</van-tabbar-item>
    <van-tabbar-item to="/daka" icon="todo-list-o">打卡</van-tabbar-item>
    <van-tabbar-item to="/notification" icon="envelop-o" :dot="noReadNotify">消息</van-tabbar-item>
    <van-tabbar-item to="/my" icon="contact">我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from 'vuex'
import { Tabbar, TabbarItem } from 'vant'
import { notifyCheck } from '@/api/notify'

export default {
  name: 'Tabbar',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  computed: {
    ...mapGetters([
      'username'
    ]),
    active: {
      get () {
        if (this.$route.path === '/') {
          return 0
        } else if (this.$route.path === '/explore') {
          return 1
        } else if (this.$route.path === '/daka') {
          return 2
        } else if (this.$route.path === '/notification') {
          return 3
        } else if (this.$route.path === '/my') {
          return 4
        }
        return 0
      },
      set (newValue) {}
    }
  },
  data () {
    return {
      noReadNotify: false
    }
  },
  created () {
    this.checkNotify()
  },
  methods: {
    async checkNotify () {
      if (!this.username) {
        return
      }
      const response = await notifyCheck()
      this.noReadNotify = response.data.no_read_notify || false
    }
  }
}
</script>

<style scoped lang="scss">
  .van-tabbar {
    max-width: 750PX;
    position: fixed;
    bottom: 0;
  }
</style>
